import { sliderIn } from '@/components/features/casino/crash/GameBox/PreviourRoundResult/styles';

export const getTableRowProps = (item: any, loading?: boolean) => {
  return {
    sx: {
      animation: item.animateItem ? `${sliderIn} 0.3s ease-in-out` : undefined,
      opacity: loading ? 0.5 : undefined,
      pointerEvents: loading ? 'none' : undefined,
    },
    onAnimationStart: (e) => {
      if (e.animationName === sliderIn.name) {
        item.animateItem = false;
      }
    },
  };
};
